import { OnboardingDataLayerEvent } from "../types/onboardingDataLayerEvent"

export const OnboardingPostOctoshieldEvents = [
    // OrderSummaryEvents
    OnboardingDataLayerEvent.OrderSummaryViewed,
    OnboardingDataLayerEvent.OrderSummarySuccess,
    OnboardingDataLayerEvent.OrderSummaryValidated,
    // PrepaymentEvents
    OnboardingDataLayerEvent.MeeloEvent,
    OnboardingDataLayerEvent.PrepaymentRequested,
    OnboardingDataLayerEvent.PrepaymentError,
    OnboardingDataLayerEvent.PrepaymentExpired,
    OnboardingDataLayerEvent.PrepaymentFailed,
    OnboardingDataLayerEvent.PrepaymentCancelled,
    OnboardingDataLayerEvent.PrepaymentPending,
    OnboardingDataLayerEvent.PrepaymentSuccess,
    OnboardingDataLayerEvent.MandateSubmitted,
    // SubscriptionEvents
    OnboardingDataLayerEvent.SubscriptionCompleted,
] as const satisfies OnboardingDataLayerEvent[]
